// Existing owner-created artwork already referenced by the Greta project.
// Keep images whole: many contain designed text. Render them as artwork/illustrations, never live customer results.
export const agentArtwork = {
  "repupgradeMark": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2Uvd2VicA==/0e5f380d2c6238123441c04406ce9f9b.webp",
    "width": 256,
    "height": 256,
    "title": "RepUpgrade.ai mark",
    "alt": "RepUpgrade.ai brand mark"
  },
  "repupgradeDesktop": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/4b22f0cc789280cf2dac47672a471667.jpg",
    "width": 1920,
    "height": 1080,
    "title": "Ask your reputation a useful question",
    "alt": "RepUpgrade.ai desktop product illustration showing review context and a conversation"
  },
  "repupgradeMobile": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/ab50d6ab6ed6cc70b25f3d4cdde5f486.jpg",
    "width": 608,
    "height": 1080,
    "title": "A conversation you can return to",
    "alt": "RepUpgrade.ai mobile product illustration"
  },
  "reviewsExplained": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/263ec6f4affb30b4397a81cde597456c.jpg",
    "width": 1200,
    "height": 600,
    "title": "Bring the reputation signals together",
    "alt": "Illustration of customer reviews and a RepUpgrade.ai conversation"
  },
  "ratingGoal": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/d043dd6f21f828f77e3795cbda95aef8.jpg",
    "width": 1620,
    "height": 1080,
    "title": "Understand the rating goal",
    "alt": "Illustrative rating-goal and reputation report"
  },
  "reputationOverview": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/c90081acd02722d4eab7f27bbd9487e4.jpg",
    "width": 1620,
    "height": 1080,
    "title": "See the wider picture",
    "alt": "Illustrative reputation overview with reviews, performance, and visibility signals"
  },
  "feedbackToAction": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/e0985c795af4fdfca9c75994b98f0b22.jpg",
    "width": 1620,
    "height": 1080,
    "title": "From feedback to a useful next step",
    "alt": "Illustration connecting customer feedback, RepUpgrade.ai interpretation, and the next action"
  },
  "mabelMark": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/bbc34b95a70714e3b3da455a906fa545.png",
    "width": 128,
    "height": 128,
    "title": "Mabel Writes mark",
    "alt": "Mabel Writes brand mark"
  },
  "mabelPortrait": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/82990d71fe7dfc64c788f7b6d8b4f793.jpg",
    "width": 608,
    "height": 1080,
    "title": "Meet Mabel Writes",
    "alt": "Original Mabel Writes character artwork"
  },
  "mabelPoster": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/adb14aca5497002c0ba47823e56aee01.jpg",
    "width": 608,
    "height": 1080,
    "title": "Customer language becomes useful content",
    "alt": "Mabel Writes illustrated article and FAQ workflow"
  },
  "rubyMark": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/5b56ba4447aa94b9a0fdb89eda74a09b.png",
    "width": 128,
    "height": 128,
    "title": "Ruby Replies mark",
    "alt": "Ruby Replies brand mark"
  },
  "rubyPortrait": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/a28258f02e2ce4d48ac82a979157ee3a.jpg",
    "width": 608,
    "height": 1080,
    "title": "Meet Ruby Replies",
    "alt": "Original Ruby Replies character artwork"
  },
  "rubyPoster": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/ea0ac36ccc299ab4c108c50d978f1e18.jpg",
    "width": 608,
    "height": 1080,
    "title": "A thoughtful response in your voice",
    "alt": "Ruby Replies illustrated review-response workflow"
  },
  "annieMark": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/243948092d124d7dea2e58a27ac6580d.png",
    "width": 128,
    "height": 128,
    "title": "Annie Amplifies mark",
    "alt": "Annie Amplifies brand mark"
  },
  "anniePortrait": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/d0c30b1a69777be1b74d99a8e7b8df63.jpg",
    "width": 608,
    "height": 1080,
    "title": "Meet Annie Amplifies",
    "alt": "Original Annie Amplifies character artwork"
  },
  "annieBanner": {
    "src": "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/407a908a7f6869c73bb717a8b055781f.png",
    "width": 1920,
    "height": 788,
    "title": "Carry customer praise into social content",
    "alt": "Annie Amplifies illustrated social-post workflow"
  }
};

export const agentMedia = {
  "repupgrade-ai": { mark: agentArtwork.repupgradeMark, hero: agentArtwork.repupgradeDesktop, gallery: [agentArtwork.reviewsExplained, agentArtwork.ratingGoal, agentArtwork.reputationOverview, agentArtwork.feedbackToAction, agentArtwork.repupgradeMobile] },
  mabel: { mark: agentArtwork.mabelMark, hero: agentArtwork.mabelPortrait, gallery: [agentArtwork.mabelPoster] },
  ruby: { mark: agentArtwork.rubyMark, hero: agentArtwork.rubyPortrait, gallery: [agentArtwork.rubyPoster] },
  annie: { mark: agentArtwork.annieMark, hero: agentArtwork.anniePortrait, gallery: [agentArtwork.annieBanner] },
};